import { createCodec, Struct, u32, Enum } from 'scale-ts';
import { v15 } from './v15.mjs';
import { v14 } from './v14.mjs';

const unsupportedFn = () => {
  throw new Error("Unsupported metadata version!");
};
const unsupported = createCodec(
  unsupportedFn,
  unsupportedFn
);
const metadata = Struct({
  magicNumber: u32,
  metadata: Enum({
    v0: unsupported,
    v1: unsupported,
    v2: unsupported,
    v3: unsupported,
    v4: unsupported,
    v5: unsupported,
    v6: unsupported,
    v7: unsupported,
    v8: unsupported,
    v9: unsupported,
    v10: unsupported,
    v11: unsupported,
    v12: unsupported,
    v13: unsupported,
    v14,
    v15
  })
});

export { metadata };
//# sourceMappingURL=metadata.mjs.map
